import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=01931164"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PrismicSlice: require('/home/runner/work/marketing/marketing/components/PrismicSlice.vue').default})
